export const categories = [
  { slug: 'dongzuo', name: '动作片', icon: 'ri-sword-line', description: '热血激战、拳拳到肉的动作大片' },
  { slug: 'xiju', name: '喜剧片', icon: 'ri-emotion-laugh-line', description: '轻松搞笑、笑料不断的欢乐佳作' },
  { slug: 'kehuan', name: '科幻片', icon: 'ri-rocket-line', description: '未来世界、星际冒险的视觉盛宴' },
  { slug: 'aiqing', name: '爱情片', icon: 'ri-heart-line', description: '浪漫动人、感人心扉的爱情故事' },
  { slug: 'kongbu', name: '恐怖片', icon: 'ri-ghost-line', description: '惊悚刺激、毛骨悚然的恐怖体验' },
  { slug: 'donghua', name: '动画片', icon: 'ri-movie-line', description: '精彩纷呈、老少皆宜的动画世界' },
  { slug: 'fanzui', name: '犯罪片', icon: 'ri-police-car-line', description: '悬疑烧脑、紧张刺激的犯罪故事' },
  { slug: 'zhanzheng', name: '战争片', icon: 'ri-shield-flash-line', description: '宏大场面、震撼人心的战争史诗' },
];

export const movies = [
  {
    id: 1,
    title: '星际战魂',
    slug: 'xingji-zhanhun',
    category: 'kehuan',
    year: 2026,
    rating: 8.7,
    duration: '148分钟',
    director: '张星宇',
    cast: ['刘昊天', '陈雨桐', '王浩然', '林思涵'],
    poster: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20poster%20with%20a%20spaceship%20battle%20in%20deep%20space%2C%20epic%20space%20war%20scene%20with%20laser%20beams%20and%20explosions%2C%20cinematic%20lighting%2C%20dramatic%20composition%2C%20warm%20orange%20and%20gold%20accents%20on%20dark%20background%2C%20professional%20movie%20poster%20style%20with%20Chinese%20typography%20space&width=600&height=900&seq=movie-01&orientation=portrait',
    description: '公元2150年，人类在星际殖民中遭遇未知外星文明。年轻的舰长林风率领星际舰队与强大的外星势力展开殊死搏斗。在这场关乎人类存亡的战争中，他不仅要面对强大的敌人，更要直面内心对战争与和平的艰难抉择。影片以震撼的视觉特效和深刻的主题，展现了人类在浩瀚宇宙中的勇气与智慧。',
    isHot: true,
    isNew: true,
    isFeatured: true,
    views: '1280万',
  },
  {
    id: 2,
    title: '笑傲江湖之风云再起',
    slug: 'xiaoao-jianghu',
    category: 'dongzuo',
    year: 2025,
    rating: 9.1,
    duration: '136分钟',
    director: '李剑心',
    cast: ['赵文卓', '周韵', '吴京', '张晋'],
    poster: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20movie%20poster%20with%20a%20swordsman%20in%20flowing%20white%20robes%20standing%20on%20a%20mountain%20peak%2C%20ancient%20Chinese%20landscape%20with%20misty%20mountains%2C%20dramatic%20golden%20hour%20lighting%2C%20epic%20wuxia%20style%2C%20traditional%20Chinese%20ink%20painting%20aesthetic%2C%20cinematic%20composition&width=600&height=900&seq=movie-02&orientation=portrait',
    description: '江湖风云变幻，一代大侠令狐冲隐退多年后再次被卷入武林纷争。面对旧敌新友，他必须重拾长剑，守护心中那份侠义与自由。影片融合了传统武侠精神与现代动作美学，打斗场面行云流水，令人叹为观止。',
    isHot: true,
    isNew: false,
    isFeatured: true,
    views: '2350万',
  },
  {
    id: 3,
    title: '疯狂的假期',
    slug: 'fengkuang-jiaqi',
    category: 'xiju',
    year: 2026,
    rating: 8.4,
    duration: '112分钟',
    director: '宁财神',
    cast: ['沈腾', '马丽', '艾伦', '常远'],
    poster: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20comedy%20movie%20poster%20with%20a%20family%20on%20a%20chaotic%20vacation%2C%20bright%20tropical%20beach%20background%2C%20comedic%20expressions%2C%20colorful%20and%20vibrant%20style%2C%20warm%20sunny%20lighting%2C%20playful%20composition%2C%20summer%20holiday%20vibe&width=600&height=900&seq=movie-03&orientation=portrait',
    description: '一个普通的上班族家庭决定来一场说走就走的旅行，却意外卷入了一系列啼笑皆非的乌龙事件。从错过航班到住错酒店，从语言不通到文化碰撞，这趟旅程充满了意想不到的惊喜与欢笑。',
    isHot: true,
    isNew: true,
    isFeatured: true,
    views: '1890万',
  },
  {
    id: 4,
    title: '深海迷踪',
    slug: 'shenhai-mizong',
    category: 'kehuan',
    year: 2025,
    rating: 8.6,
    duration: '142分钟',
    director: '陈凯歌',
    cast: ['黄渤', '章子怡', '段奕宏', '谭卓'],
    poster: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20sea%20sci-fi%20movie%20poster%20with%20an%20underwater%20research%20station%2C%20bioluminescent%20creatures%20in%20the%20dark%20ocean%2C%20deep%20blue%20and%20teal%20color%20palette%2C%20atmospheric%20lighting%2C%20mysterious%20and%20thrilling%20vibe%2C%20cinematic%20underwater%20photography%20style&width=600&height=900&seq=movie-04&orientation=portrait',
    description: '一支深海科考队在万米深渊发现了一座神秘的水下遗迹。随着探索的深入，他们逐渐揭开了人类文明起源的惊天秘密。然而，深海中潜伏的未知生物正悄然逼近...影片以惊人的水下摄影技术，呈现了一个令人窒息的深海世界。',
    isHot: false,
    isNew: false,
    isFeatured: true,
    views: '1560万',
  },
  {
    id: 5,
    title: '无名之辈',
    slug: 'wuming-zhibei',
    category: 'fanzui',
    year: 2024,
    rating: 9.0,
    duration: '125分钟',
    director: '饶晓志',
    cast: ['陈建斌', '任素汐', '章宇', '王砚辉'],
    poster: 'https://readdy.ai/api/search-image?query=Gritty%20Chinese%20crime%20drama%20movie%20poster%20with%20rainy%20urban%20street%20scene%2C%20neon%20lights%20reflecting%20on%20wet%20asphalt%2C%20noir%20atmosphere%2C%20dark%20alley%20with%20a%20solitary%20figure%2C%20moody%20cinematic%20lighting%2C%20intense%20and%20raw%20emotional%20tone&width=600&height=900&seq=movie-05&orientation=portrait',
    description: '一个小城的两名笨贼与一名高位截瘫的女子，在一夜之间命运交织。荒诞与现实交织，黑色幽默中透着人性的光芒。影片以独特的视角展现了社会底层小人物的挣扎与尊严，笑中带泪，震撼人心。',
    isHot: false,
    isNew: false,
    isFeatured: false,
    views: '980万',
  },
  {
    id: 6,
    title: '夏日恋歌',
    slug: 'xiari-liange',
    category: 'aiqing',
    year: 2026,
    rating: 8.2,
    duration: '118分钟',
    director: '陈思诚',
    cast: ['刘亦菲', '肖战', '杨紫', '李现'],
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20love%20story%20movie%20poster%20with%20a%20couple%20walking%20on%20a%20sunset%20beach%2C%20soft%20golden%20hour%20light%2C%20gentle%20ocean%20waves%2C%20warm%20and%20dreamy%20atmosphere%2C%20romantic%20film%20aesthetic%2C%20soft%20focus%20photography%20style&width=600&height=900&seq=movie-06&orientation=portrait',
    description: '两个在异国他乡相遇的年轻人，在最美的夏天谱写了一段刻骨铭心的恋曲。从陌生到熟悉，从争吵到理解，他们的爱情如同夏日的阳光，炽热而美好。但现实的距离与梦想的追求，让这段感情面临重重考验。',
    isHot: false,
    isNew: true,
    isFeatured: false,
    views: '1670万',
  },
  {
    id: 7,
    title: '暗夜猎手',
    slug: 'anye-lieshou',
    category: 'kongbu',
    year: 2025,
    rating: 8.0,
    duration: '105分钟',
    director: '温子仁',
    cast: ['张震', '舒淇', '彭于晏', '周迅'],
    poster: 'https://readdy.ai/api/search-image?query=Horror%20movie%20poster%20with%20a%20dark%20haunted%20mansion%20in%20the%20woods%2C%20full%20moon%20night%2C%20foggy%20atmosphere%2C%20silhouette%20of%20a%20mysterious%20figure%2C%20cold%20blue%20and%20deep%20shadow%20tones%2C%20thrilling%20and%20creepy%20cinematic%20style&width=600&height=900&seq=movie-07&orientation=portrait',
    description: '一群年轻人来到深山中的古宅度假，却不知这里隐藏着不为人知的恐怖秘密。当夜幕降临，古宅中的诡异事件接连发生，他们被迫面对最深的恐惧。影片以精妙的悬疑设计和惊悚氛围，打造了一部让人窒息的恐怖佳作。',
    isHot: false,
    isNew: false,
    isFeatured: false,
    views: '780万',
  },
  {
    id: 8,
    title: '龙族崛起',
    slug: 'longzu-jueqi',
    category: 'donghua',
    year: 2026,
    rating: 9.3,
    duration: '132分钟',
    director: '田晓鹏',
    cast: ['边江', '张杰', '季冠霖', '乔诗语'],
    poster: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20movie%20poster%20with%20a%20majestic%20dragon%20soaring%20through%20clouds%2C%20ancient%20Chinese%20mythological%20style%2C%20vibrant%20gold%20and%20red%20color%20palette%2C%20traditional%20Chinese%20art%20aesthetic%2C%20dynamic%20composition%2C%20grand%20and%20heroic%20atmosphere&width=600&height=900&seq=movie-08&orientation=portrait',
    description: '在一个人类与龙族共存的世界中，少年阿龙发现自己拥有与远古龙族沟通的神秘能力。当黑暗势力威胁世界和平，他必须联合龙族力量，踏上拯救苍生的冒险旅程。影片以精美的画面和宏大的世界观，重新定义了中国动画的高度。',
    isHot: true,
    isNew: true,
    isFeatured: true,
    views: '3210万',
  },
  {
    id: 9,
    title: '铁血战魂',
    slug: 'tiexue-zhanhun',
    category: 'zhanzheng',
    year: 2024,
    rating: 8.8,
    duration: '156分钟',
    director: '林超贤',
    cast: ['吴京', '张译', '段奕宏', '易烊千玺'],
    poster: 'https://readdy.ai/api/search-image?query=War%20movie%20poster%20with%20soldiers%20on%20a%20battlefield%2C%20dramatic%20explosion%20in%20the%20background%2C%20rugged%20military%20aesthetic%2C%20dust%20and%20smoke%20atmosphere%2C%20heroic%20composition%2C%20intense%20and%20gritty%20cinematic%20style%2C%20warm%20sepia%20tones&width=600&height=900&seq=movie-09&orientation=portrait',
    description: '还原真实历史战役，讲述一支精锐部队在绝境中坚守阵地、浴血奋战的壮烈故事。面对数倍于己的敌人，他们以钢铁般的意志铸就了不朽的传奇。影片以震撼的战争场面和细腻的人物刻画，致敬每一位为国捐躯的英雄。',
    isHot: false,
    isNew: false,
    isFeatured: false,
    views: '2450万',
  },
  {
    id: 10,
    title: '超能学霸',
    slug: 'chaoneng-xueba',
    category: 'xiju',
    year: 2026,
    rating: 8.1,
    duration: '108分钟',
    director: '闫飞',
    cast: ['刘昊然', '彭昱畅', '张子枫', '赵今麦'],
    poster: 'https://readdy.ai/api/search-image?query=Funny%20Chinese%20campus%20comedy%20movie%20poster%20with%20students%20in%20a%20classroom%2C%20chaotic%20and%20hilarious%20scene%2C%20bright%20school%20setting%2C%20playful%20expressions%2C%20colorful%20and%20energetic%20style%2C%20youth%20comedy%20vibe&width=600&height=900&seq=movie-10&orientation=portrait',
    description: '一个普通高中生意外获得了超能力，却发现每次使用都会带来意想不到的乌龙后果。在高考倒计时的压力下，他必须学会掌控自己的能力，同时还要面对青春期的种种烦恼。笑料百出中透着青春的温暖与感动。',
    isHot: false,
    isNew: true,
    isFeatured: false,
    views: '1340万',
  },
  {
    id: 11,
    title: '荒野求生',
    slug: 'huangye-qiusheng',
    category: 'dongzuo',
    year: 2025,
    rating: 8.5,
    duration: '128分钟',
    director: '吴京',
    cast: ['吴京', '张涵予', '李晨', '郑恺'],
    poster: 'https://readdy.ai/api/search-image?query=Survival%20action%20movie%20poster%20with%20a%20man%20climbing%20a%20rugged%20mountain%2C%20vast%20wilderness%20landscape%2C%20dramatic%20storm%20clouds%2C%20golden%20sunset%20lighting%2C%20adventure%20and%20survival%20theme%2C%20epic%20cinematic%20composition&width=600&height=900&seq=movie-11&orientation=portrait',
    description: '一架飞机在荒原坠毁，唯一的幸存者必须穿越数百公里的无人区才能获救。面对极端天气、野兽袭击和食物短缺，他凭借着顽强的求生意志一次次战胜死亡的威胁。影片以真实到令人窒息的荒野场景，诠释了人类求生本能的伟大。',
    isHot: false,
    isNew: false,
    isFeatured: false,
    views: '1120万',
  },
  {
    id: 12,
    title: '时光情书',
    slug: 'shiguang-qingshu',
    category: 'aiqing',
    year: 2024,
    rating: 8.9,
    duration: '122分钟',
    director: '曾国祥',
    cast: ['周冬雨', '易烊千玺', '张子枫', '刘昊然'],
    poster: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20drama%20movie%20poster%20with%20a%20couple%20under%20cherry%20blossom%20trees%2C%20soft%20spring%20lighting%2C%20nostalgic%20and%20warm%20atmosphere%2C%20dreamy%20film%20aesthetic%2C%20gentle%20pink%20and%20cream%20tones%2C%20emotional%20and%20touching%20style&width=600&height=900&seq=movie-12&orientation=portrait',
    description: '一封尘封多年的情书，串联起两代人的爱情故事。当孙女在整理奶奶遗物时发现了这封信，一段被岁月掩埋的动人爱情逐渐浮出水面。影片以细腻的叙事和深刻的情感，唤起了每个人心中关于爱与时光的记忆。',
    isHot: false,
    isNew: false,
    isFeatured: false,
    views: '890万',
  },
];

export const featuredMovies = movies.filter(m => m.isFeatured);
export const hotMovies = movies.filter(m => m.isHot);
export const newMovies = movies.filter(m => m.isNew);

export const aboutInfo = {
  brandName: '悟空影视',
  tagline: '齐天大圣带你畅游光影世界',
  founded: '2018年',
  mission: '让每一位影迷都能随时随地畅享高清电影，打造中国最优质的免费在线观影平台。',
  intro: '悟空影视创立于2018年，以中国经典神话人物"孙悟空"为品牌形象，取"七十二变"之意，寓意平台内容丰富多彩，应有尽有。经过多年发展，悟空影视已成为国内领先的免费高清电影在线播放平台，日活跃用户超过500万。',
  features: [
    { title: '海量片库', description: '涵盖动作、喜剧、科幻、爱情、恐怖、动画等多个品类，片库数量超过10万部，新片上映同步更新。' },
    { title: '高清画质', description: '全站采用H.265编码技术，支持1080P及4K超高清画质播放，带给您影院级的观影体验。' },
    { title: '即点即播', description: '采用全球CDN加速技术，无需下载、无需缓冲，点击即可流畅播放，告别等待烦恼。' },
    { title: '多端适配', description: '完美适配电脑、平板、手机等各类设备，随时随地想看就看，观影不受场景限制。' },
  ],
  reputation: [
    { text: '悟空影视的片源真的太全了，每次想看电影第一个就想到这里，画质清晰还不卡顿！', author: '影迷小陈', rating: 5 },
    { text: '用悟空影视三年了，从经典老片到最新大片都能找到，推荐的分类也很精准，强烈推荐！', author: '电影爱好者阿明', rating: 5 },
    { text: '家里老人孩子都爱看，操作简单，分类清楚，最重要的是完全免费，良心平台！', author: '家庭用户李女士', rating: 5 },
    { text: '作为一名电影发烧友，悟空影视的更新速度让我惊喜，很多院线新片很快就能在这里看到。', author: '影评人老王', rating: 5 },
    { text: '界面简洁大方，没有乱七八糟的广告弹窗，观影体验非常棒，已经安利给身边所有朋友了。', author: '大学生小周', rating: 5 },
  ],
  contact: {
    email: 'service@wukongmovies.com',
    wechat: '悟空影视官方',
    weibo: '@悟空影视',
    address: '北京市朝阳区望京科技园A座',
  },
};